import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledCarousel } from "reactstrap";

// Core Components
import PageNavbar from "../../components/navbars/PageNavbar";
import SiteFooter from "../../components/footers/SiteFooter";

// Core Components
import { donate } from "../../assets/data/photos";

function CarouselSection() {
  return (
    <>
      <PageNavbar />
      <div
        className="section"
        style={{
          backgroundImage:
            "url(" + require("assets/img/ill/testimonial_bg.svg") + ")",
        }}
      >
        <Container className="py-md">
          <Row className="justify-content-between align-items-center">
            <Col className="mb-lg-auto" lg="6">
              <div className="rounded overflow-hidden transform-perspective-left">
                <UncontrolledCarousel items={donate} />
              </div>
            </Col>
            <Col className="mb-5 mb-lg-0" lg="5">
              <h3 className="display-3">
                Please donate. <br />
                No amount too big or too small.
              </h3>
              <br />
              <h2 className="display-4">Bank details:</h2>
              <p className="lead mt-0">
                Hannah's Place of Safety <br />
                Standard Bank <br />
                272889261 <br />
                Current acc <br />
                Ref Jessi100 <br />
                Email POP to{" "}
                <a href="mailto:mentor.tamsyn@gmail.com">
                  mentor.tamsyn@gmail.com
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <SiteFooter />
    </>
  );
}

export default CarouselSection;
